const RangeSliderFilterPartial = {
  parts: [
    'container',
    'labelContainer',
    'label',
    'rangeSlider',
    'sliderTrack',
    'sliderFilledTrack',
    'sliderThumb',
    'minMaxContainer',
    'minMaxInput',
    'maxMaxInput'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 4, // 16px
      py: 4, // 16px
      px: 4, // 16px
      alignSelf: 'stretch',
      position: 'relative',
    },

    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'stretch',
      mb: 2, // 8px
    },

    label: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
    },

    rangeSlider: {
      alignSelf: 'stretch',
    },

    sliderTrack: {
      bg: 'brandColors.greyscale10',
      h: '4px',
    },

    sliderFilledTrack: {
      bg: 'brandColors.primaryDarkLinen', // #8C683B
    },

    sliderThumb: {
      w: 4, // 16px
      h: 4, // 16px
      bg: 'white', // #FFF
      border: '2px solid',
      borderColor: 'brandColors.primaryDarkLinen', // #8C683B
    },

    minMaxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'stretch',
      mt: 2, // 8px
    },

    minMaxInput: {
      w: '80px',
      h: 'auto',
      px: 4, // 16px
      py: 2, // 8px
      borderRadius: '4px',
      border: '1px solid',
      borderColor: 'brandColors.greyscale10', // rgba(27, 26, 24, 0.10)
      bg: 'white', // #FFF
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontWeight: 'normal',
      lineHeight: '120%',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      _placeholder: {
        color: 'brandColors.greyscale70', // rgba(27, 26, 24, 0.70)
      },
      _focus: {
        borderColor: 'brandColors.primaryDarkLinen',
        boxShadow: 'none',
        outline: 'none',
      },
    },

    maxMaxInput: {
      w: '80px',
      h: 'auto',
      px: 4, // 16px
      py: 2, // 8px
      borderRadius: '4px',
      border: '1px solid',
      borderColor: 'brandColors.greyscale10', // rgba(27, 26, 24, 0.10)
      bg: 'white', // #FFF
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontWeight: 'normal',
      lineHeight: '120%',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      _placeholder: {
        color: 'brandColors.greyscale70', // rgba(27, 26, 24, 0.70)
      },
      _focus: {
        borderColor: 'brandColors.primaryDarkLinen',
        boxShadow: 'none',
        outline: 'none',
      },
    },
  },
};

export default RangeSliderFilterPartial;
